import styled from 'styled-components'
import theme from '../../../styles/theme'

function Popup({ onClose }) {
  return (
    <Overlay>
      <PopupBox>
        <ExhibitionImage
          src="/assets/secon/secon.png"
          alt="전시회 홍보 이미지"
        />
        <ButtonRow>
          <CloseButton onClick={onClose}>닫기</CloseButton>
          <RegisterButton
            href="https://egisec.imasia-passport.com/ko?utm_source=invi&utm_medium=exh&utm_campaign=sPresto%20Co.,%20Ltd"
            target="_blank"
            rel="noopener noreferrer"
          >
            무료 사전관람등록
          </RegisterButton>
        </ButtonRow>
      </PopupBox>
    </Overlay>
  )
}

export default Popup

// styled-components

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const PopupBox = styled.div`
  background: ${theme.color.WPrimary};
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: min(480px, 90vw);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
`

const ExhibitionImage = styled.img`
  width: 100%;
  display: block;
  object-fit: cover;
`

const ButtonRow = styled.div`
  display: flex;
  border-top: 1px solid ${theme.color.WSecondary};
`

const CloseButton = styled.button`
  flex: 1;
  padding: 16px 0;
  background: ${theme.color.WSecondary};
  color: ${theme.color.TPrimary};
  font-size: 15px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #ddd;
  }
`

const RegisterButton = styled.a`
  flex: 1;
  padding: 16px 0;
  background: ${theme.color.GPrimary};
  color: ${theme.color.WPrimary};
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #009aaa;
  }
`
